import { styled } from '@olxeu-jobs/ui';

export const Hr = styled('hr', ({ $theme }) => ({
  width: '100%',
  borderBottom: 0,
  borderLeft: 0,
  borderRight: 0,
  borderTop: `1px solid ${$theme.colors['borders-global-tertiary']}`,
  marginTop: $theme.space[16],
  marginBottom: $theme.space[16],
}));
